import {
  Backdrop,
  Button,
  Checkbox,
  ClickAwayListener,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Snackbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import loader from "../../assets/Lotties/Loader.json";
import { Player } from "@lottiefiles/react-lottie-player";
import selfie from "../../assets/Lotties/selfie.json";
import { Alert } from "@mui/lab";
import ContentCopyTwoToneIcon from "@mui/icons-material/ContentCopyTwoTone";
import CloseIcon from "@mui/icons-material/Close";
const Dialogs = (props: any) => {
  const [open, setOpen] = useState(false);

  const handleTooltipOpen = () => {
    setOpen(true);
    setTimeout(() => {
      handleTooltipClose();
    }, 1000); // Close after 1 second
  };
const [termsChecked, setTermsChecked] = useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div>
        <Snackbar
          open={props.openSnackbar}
          onClose={props.handleClose}
          autoHideDuration={2000}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          className="errorSnackBar"
        >
          <Alert onClose={props.handleClose} severity="error">
            {props.errorsnackmsg}
          </Alert>
        </Snackbar>
      </div>
      <Dialog
        open={props.openSuccess}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogContent className="confirmationPopup ">
          <div>
            <svg
              className="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="checkmark__circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="checkmark__check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
            <Typography component={"h5"} variant="h5">
              Your mobile no. has been updated successfully.
            </Typography>
            <p>
              <b>
                Application reference no.: <span>{props?.applicationNo}</span>
                <br />
                You can raise another request for mobile number update after 7
                days.
              </b>
            </p>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => {
                props.handleCloseSuccess();
              }}
              className="blueBtn"
              disableElevation
            >
              Back To Home
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={props.openSuccessEmail}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogContent className="confirmationPopup ">
          <div>
            <svg
              className="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="checkmark__circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="checkmark__check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
            <Typography component={"h5"} variant="h5">
              Your Email has been updated successfully.
            </Typography>
            <p>
              <b>
                Application reference no.: <span>{props?.applicationNo}</span>
                <br />
                You can raise another request for email update after 7 days.
              </b>
            </p>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => {
                props.handleCloseSuccessEmail();
              }}
              className="blueBtn"
              disableElevation
            >
              Back To Home
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {/* openselfieurl open */}
      <Dialog
        open={props.openSelfieUrl}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="mobile-email-update selfiLink"
      >
        <DialogTitle className="title">
          {/* {"confirmation"} */}
          <Grid className="actionBtn">
            <IconButton
              onClick={props.handleOpenCloseConfirmation}
              size="small"
              className="selfiecloseBtn"
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent className="confirmationPopup ">
          <Player
            src={selfie}
            className="playerWallet"
            loop
            autoplay
            style={{
              height: "auto",
              width: "110px",
              transform: "rotate(-360deg)",
            }}
          />
          <div className="content">
            Please take a selfie using the link sent to your email/mobile or copy
            <ClickAwayListener onClickAway={handleTooltipClose}>
              <Tooltip
                // PopperProps={{
                //   disablePortal: true,
                // }}
                onClose={handleTooltipClose}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title="Link copied"
              >
                <IconButton
                  onClick={() => {
                    navigator.clipboard.writeText(props.getOpenSelfieUrlCopy);
                    handleTooltipOpen();
                  }}
                >
                  <ContentCopyTwoToneIcon />
                </IconButton>
              </Tooltip>
            </ClickAwayListener>
            link, then click "Continue" to proceed to the next step.
            <Button
              onClick={props.handleFetchEsign}
              className="button-primary-custom blueBtn"
            >
              Continue
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {/* completed selfie  */}
      <Dialog
        open={props.openDoneSelfie}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogContent className="confirmationPopup selfieComplete">
          <div>
            To proceed, please click "Continue" on the web page to complete your
            application.
          </div>
        </DialogContent>
      </Dialog>

      {/* Cancel selfie  */}
      <Dialog
        open={props.openCancelSelfie}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogContent className="confirmationPopup selfieComplete">
          <div>
            Please refresh the window to access the selfie screen again.
          </div>
        </DialogContent>
      </Dialog>

      <Backdrop open={props.getLoader} className="backD">
        <div className="Wallet">
          <Player
            src={loader}
            className="playerWallet"
            loop
            autoplay
            style={{
              height: "auto",
              width: "110px",
              transform: "rotate(-360deg)",
            }}
          />
        </div>
      </Backdrop>
      <Dialog
        open={props.openOptOutConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogTitle id="responsive-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent className="confirmationPopup confirmationModal">
          <div>Are you sure you want to opt out nominee?</div>
                      <div className="checker" style={{backgroundColor: "#f5f5f5", padding: "10px", borderRadius: "5px", marginTop: "10px"  }}>
              <Typography>Terms and Conditions</Typography>
              <Checkbox
                checked={termsChecked}
                onChange={(e) => setTermsChecked(e.target.checked)}
                color="primary"
                size="small"
                sx={{    padding: "0"}}
              />
              <label htmlFor="termsCheckbox" style={{ fontSize: "12px" }}>
           <span> I hereby confirm that I do not wish to appoint anynominee(s) to my demat account/ mutual fund folio atthis point of time.</span>
            <span>I understand that<br/><b>(i)</b> The nomination helps to quickly identify the person for transfer of securities and helps in faster and smoother transmission of my securities to my legal heir(s) after my demise.<br/><b>(ii)</b> In the absence of a nomination, my legal heir(s) may require the submission of  certain  additional  legal  or  court-issued  documents  which  may  delay  the process of transmission of securities to my legal heir(s).<br/><b>(iii)</b> If  no  claim  is  made  on  the  account  /  folio  for  a  prolonged  period  after  my demise, the holdings may be treated as unclaimed assets and they may be transferred  to  Investor  Education  and  protection  Fund  Authority  (IEPF)  in accordance with the applicable regulatory framework. <br/>I confirm that I have understood the above implications andthat my decision to opt out of nomination is voluntary.</span>
              </label>
            </div>
          <Button onClick={props.handleOptOutNominee} disabled={!termsChecked}>
            yes
          </Button>
          <Button onClick={props.handleOptOutConfirmation}>no</Button>
        </DialogContent>
      </Dialog>

      {/* delete nominee */}
      <Dialog
        open={props.deleteConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogTitle id="responsive-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent className="confirmationPopup confirmationModal">
          <div>Are you sure you want to delete this nominee?</div>
          <Button onClick={props.removeFormFields}>yes</Button>
          <Button onClick={props.handleCancelDelete}>no</Button>
        </DialogContent>
      </Dialog>
      {/* close confirmation */}
      <Dialog
        open={props.openCloseConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogTitle id="responsive-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent className="confirmationPopup confirmationModal">
          <div>Are you sure you want to close?</div>
          <Button onClick={props.handleCloseAfterConfirmation}>yes</Button>
          <Button onClick={props.handleCloseConfirmation}>no</Button>
        </DialogContent>
      </Dialog>
      {/* close confirmation */}
      {/* <Dialog
        open={props.openSubmitConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogTitle id="responsive-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent className="confirmationPopup confirmationModal">
          <div>
            Are you sure you want to add the bank? Once added, you won't be able
            to edit the details again
          </div>
          <Button onClick={props.handleSubmit}>yes</Button>
          <Button onClick={props.cancelAddBank}>no</Button>
        </DialogContent>
      </Dialog> */}
      {/* close confirmation */}
      {/* <Dialog
        open={props.openAddBankConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogTitle id="responsive-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent className="confirmationPopup confirmationModal">
          <div>
            Are you sure you want to add the bank? Once added, you won't be able
            to edit the details again
          </div>
          <Button onClick={props.handleAddBank}>yes</Button>
          <Button onClick={props.cancelAddBank}>no</Button>
        </DialogContent>
      </Dialog> */}
      {/* close confirmation */}
      <Dialog
        open={props.openUpdateBankConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogTitle id="responsive-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent className="confirmationPopup confirmationModal">
          <div>
            Are you sure you want to proceed with updating the primary bank?
            Once updated, you won't be able to edit details again
          </div>
          <Button onClick={props.handleUpdateData}>yes</Button>
          <Button onClick={props.cancelUpdateBank}>no</Button>
        </DialogContent>
      </Dialog>
      {/* close confirmation */}
      {/* <Dialog
        open={props.openPreceedWithSameBankConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogTitle id="responsive-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent className="confirmationPopup confirmationModal">
          <div>
            Are you sure you want to proceed with the existing information? Once
            confirmed, you won't be able to make any further changes
          </div>
          <Button onClick={props.handleProceedSame}>yes</Button>
          <Button onClick={props.cancelUpdateBank}>no</Button>
        </DialogContent>
      </Dialog> */}
      {/* {Bank Delete confirmation} */}
      <Dialog
        open={props.openDeleteConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogTitle id="responsive-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent className="confirmationPopup confirmationModal">
          <div>
            Are you sure you want to delete this bank account?
          </div>
          <Button onClick={props.handleDelete}>yes</Button>
          <Button onClick={props.cancelDeleteBank}>no</Button>
        </DialogContent>
      </Dialog>

      <Dialog
        open={props.openCancelConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialogsegment confirmationPopupMain mobile-email-update"
      >
        <DialogTitle id="responsive-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent className="confirmationPopup confirmationModal">
          <div>
            Are you sure you want to undo all the changes?
          </div>
          <Button onClick={props.handleCancel}>yes</Button>
          <Button onClick={props.closeCancel}>no</Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Dialogs;
